import { reactive_button } from "ui_commons";
import config from 'cfg/userinterface-config';

export const KEYS = {
    START: 119,//F8
    KEY_1: 113,//F2
    KEY_3: 114,//F3
    KEY_5: 115,//F4
    KEY_7: 116,//F5
    KEY_9: 117,//F6
    WITHDRAW: 121,//F10
    HELP: 112,//F1
    MENU: 27,//ESC
    BET: 118,//F7
    AUTO: 120//F9
};

export function createLobbyUI(
    parent,
    scenes
)
{
    const space = parent.child( "lobby_ui" );

    const getContainer = (desc) => {
        switch (desc) {
            case 'term' :
                return scenes.terms;
            case 'info' :
                return scenes.info;
            case 'event':
                return scenes.events;
            case 'lobby':
                return scenes.lobby;
        }
    };

    space.s('isTerms', false);
    space.s('isEventsChoice', false);
    space.s('isLobbyGames', false);
    space.s('isHelp', false);
    space.s('isGamesRun', false);

    const $isDemo = space.s('isDemo', parent.s('is_demo').value);
    parent.s('is_demo').to($isDemo)

    const $notShowMessage = parent.s('show_message').map(show => !show);

    const $canInteractiveUI = $isDemo.any(parent.s('show_message'), parent.s('error_driver:isError'), (demo, mess, err) => !demo && !mess && !err);

    parent.s( "keyboard" )
        .map( (event) => ({ event, consumed : false }) )
        .name( space, 'consumable_keyboard' );

    const $notHelp = space.s('isHelp').map(is => !is);
    const $notGameRun = space.s('isGamesRun').map(is => !is);
    const $notDemo = $isDemo.map(is => !is);


    const { buttons } = config;

    const createdButtons = [];

    const createButton = (desc, to, keys, { e, v, equiv} = {}) =>
    {

        createdButtons.push( desc );

        reactive_button(
            space,
            buttons,
            desc,
            to,
            keys,
            { e, v, equiv },
            getContainer(buttons[desc].scene),
        )
    };

    createButton( "prevGame",             space.s( "prevGame" ),               [ KEYS.KEY_1 ], {
        e : [
            space.s('isLobbyGames'),
            $notHelp,
            $notGameRun,
            $canInteractiveUI
            ],
        v : true,
    } );

    createButton( "nextGame",             space.s( "nextGame" ),               [ KEYS.KEY_9 ], {
        e : [
            space.s('isLobbyGames'),
            $notHelp,
            $notGameRun,
            $canInteractiveUI
        ],
        v : true,
    } );


    createButton( "choiceGame",             space.s( "choiceGame" ),               [ KEYS.START ], {
        e : [
            space.s('isLobbyGames'),
            $notHelp,
            $canInteractiveUI
        ],
        v : true,
    } );

    createButton( "changeGame",             space.s( "changeGame" ),               [ KEYS.MENU ], {
        e : [
            space.s('isGamesRun'),
            $notHelp,
            $canInteractiveUI
        ],
        v : true,
    } );

    createButton( "lobbyInfo",             space.s( "openInfo" ),               [ KEYS.HELP ], {
        e : [
            space.s('isLobbyGames'),
            $notHelp,
            $notGameRun,
            $canInteractiveUI
        ],
        v : true,
    } );

    createButton( "lobbyStopPari",             space.s( "stopPari" ),               [ KEYS.WITHDRAW ], {
        e : [
            space.s('isLobbyGames'),
            $notHelp,
            $notGameRun,//
            $canInteractiveUI
        ],
        v : true,
    } );

    createButton( "infoExit",             space.s( "infoExit" ),               [ KEYS.HELP ], {
        e : [
            space.s('isHelp'),
            $canInteractiveUI
            ],
        v : true,
    } );

    createButton( "infoForward",             space.s( "infoNext" ),               [ KEYS.KEY_9 ], {
        e : [
            space.s('isHelp'),
            $canInteractiveUI
            ],
        v : true,
    } );

    createButton( "infoBack",             space.s( "infoPrev" ),               [ KEYS.KEY_1 ], {
        e : [
            space.s('isHelp'),
            $canInteractiveUI
            ],
        v : true,
    } );

    createButton( "termsAgree",             space.s( "termsAgree" ),               [ KEYS.START ], {
        e : [
            space.s('isTerms'),
            $canInteractiveUI
            ],
        v : true,
    } );

    createButton( "prevTermPage",             space.s( "prevTermPage" ),               [ KEYS.KEY_1 ], {
        e : [
            space.s('isTerms'),
            $canInteractiveUI
            ],
        v : true,
    } );

    createButton( "nextTermPage",             space.s( "nextTermPage" ),               [ KEYS.KEY_9 ], {
        e : [
            space.s('isTerms'),
            $canInteractiveUI
            ],
        v : true,
    } );

    createButton( "eventInfo",             space.s( "openInfo" ),               [ KEYS.HELP ], {
        e : [
            space.s('isEventsChoice'),
            $notHelp,
            $notGameRun,
            $canInteractiveUI
        ],
        v : true,
    } );


    ///creating any other buttons present in configuration:
    for ( const desc in buttons )
    {
        if ( createdButtons.indexOf( desc ) >= 0 ) continue;
        createButton( desc );
    }

    //space.s( "choiceGame" ).map(() => true).to(space.s('isGamesRun'));
    //space.s( "changeGame" ).map(() => false).to(space.s('isGamesRun'));

    space.s( "openInfo" ).map(() => true).to(space.s('isHelp'));
    space.s( "infoExit" ).map(() => false).to(space.s('isHelp'));

    space.s( "termsAgree" ).map(() => false).to(space.s('isTerms'));
    space.s( "termsAgree" ).map(() => true).to(space.s('isEventsChoice'));

}



// WEBPACK FOOTER //
// ./src/lobby_ui.es6